// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list_sEmVo","item":"item_Wz56I","pic":"pic_2h361","tag":"tag_6ZQP4"};